import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { Row, Col, Image, Card, Form, Input, Button, message } from 'antd';
import EndPoints from '../../shared/endPoints/EndPoints.json';
import useHttpClient from '../../shared/sendRequest/useHttpClient';
import { useAuthContext } from '../../shared/context/auth-context';
import Img from '../../assets/btm logo.png';

export default function Profile() {
  const styles = {
    button: {
      backgroundColor: 'black',
      color: 'white',
      borderRadius: 20
    }
  };

  const [form] = Form.useForm();
  const { sendRequest } = useHttpClient();
  const { username, logout } = useAuthContext();

  const { mutate, status } = useMutation(sendRequest, {
    onSuccess: data => {
      if (data) {
        message.success('Η καταχώρηση ήταν επιτυχής').then(() => {
          logout();
        });
      }
    }
  });

  useEffect(() => {
    if (status === 'loading') {
      message.loading();
    }
  }, [status]);

  const onFinish = values => {
    mutate({
      endpoint: EndPoints.BASEURL + EndPoints.USER.CHANGEUSERNAMEANDPASSWORD,
      method: 'PUT',
      bodyData: values
    });
  };

  useEffect(() => {
    form.setFieldsValue({
      username,
      newUsername: username
    });
  }, [form]);

  return (
    <Row justify="center" align="middle" style={{ flexDirection: 'column' }}>
      <Col>
        <Image style={{ margin: 20 }} src={Img} width={350} preview={false} />
      </Col>
      <Col xs={24} md={24} style={{ paddingBottom: 30 }}>
        <Card
          headStyle={{ textAlign: 'center' }}
          title="Αλλαγή στοιχείων πρόσβασης"
        >
          <Form
            name="basic"
            labelCol={{ span: 14 }}
            form={form}
            wrapperCol={{ span: 13 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item label="Όνομα χρήστη:" name="username">
              <Input disabled />
            </Form.Item>
            <Form.Item label="Κωδικός πρόσβασης:" name="password">
              <Input.Password />
            </Form.Item>
            <Form.Item
              help="Μπορείτε να αλλάξετε το username"
              label="Νέο όνομα χρήστη:"
              name="newUsername"
            >
              <Input />
            </Form.Item>
            <Form.Item label="Νέος κωδικός πρόσβασης:" name="newPassword">
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="Επιβεβαίωση νέου κωδικού πρόσβασης:"
              name="confirmPassword"
            >
              <Input.Password />
            </Form.Item>
            <Col sm={{ span: 14, offset: 10 }}>
              <Form.Item>
                <Button style={styles.button} htmlType="submit">
                  Αλλαγή
                </Button>
              </Form.Item>
            </Col>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}
